const state = {
    route: {},
};

const mutations = {
    setRoute(state, route) {
        state.route = route;
    },
    clearRoute(state) {
        state.route = '';
    },
};

const actions = {
    async setRoute({ commit }, route) {
        commit('setRoute', route);
    },
};

const getters = {
    route(state) {
        return state.route || '';
    },
};

export default {
    state,
    mutations,
    actions,
    getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/route.js